import React from "react";
import { Award, CheckCircle, XCircle } from "react-bootstrap-icons";
import { Card, Row, Col, Button} from "react-bootstrap";
import logo from "../../../images/Logo.png";

const CourseCard = () => {
  const courses = [
    {
      title: "Foundation With SQL (2022)",
      digitalLearning: false,
      assessment: true,
      project: true,
      feedback: true,
    },
    {
      title: "Advanced SQL Techniques",
      digitalLearning: true,
      assessment: true,
      project: true,
      feedback: true,
    },
    {
      title: "Data Science Essentials",
      digitalLearning: true,
      assessment: true,
      project: true,
      feedback: true,
    },
    {
      title: "Machine Learning Basics",
      digitalLearning: true,
      assessment: true,
      project: false,
      feedback: false,
    },
    // Add more course objects here as needed
  ];
  return (
    <div className="text-center mb-3">
      <h5 className="mb-1">Essential Modules</h5>
      <p className="text-danger mb-0" style={{ fontSize: "0.875rem" }}>
        *To generate Essential Modules certificates, ensure digital learning
        process completed, project is graded, at least one assessment and batch
        feedback is submitted.
      </p>
      <Row className="g-4">
        {courses.map((course, index) => (
          <Col xs={12} sm={6} lg={6} key={index}>
            <Card
              className="w-100 mt-3 mx-auto text-dark position-relative overflow-hidden shadow-sm hover-effect"
              style={{
                height: "290px",
                position: "relative",
              }}
            >
              {/* Card Header */}
              <Card.Header className="d-flex justify-content-between align-items-center border-0">
                <h5 className="mb-0 fs-4">{course.title}</h5>
                <Award className="text-warning" size={25} />
              </Card.Header>

              {/* Background image (with opacity) */}
              <div
                className="background-image"
                style={{
                  backgroundImage: `url(${logo})`,
                  backgroundSize: "contain", 
                  backgroundPosition: "center", 
                  backgroundRepeat: "no-repeat",
                  opacity: 0.3,
                  position: "absolute",
                  top: "50%",
                  left: "50%", 
                  transform: "translate(-50%, -50%)", 
                  width: "50%",
                  height: "50%", 
                  zIndex: 1, 
                }}
              ></div>

              {/* Card Body */}
              <Card.Body className="d-flex flex-column justify-content-center fs-4">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span>Digital Learning</span>
                  {course.digitalLearning ? (
                    <CheckCircle className="text-success" size={20} />
                  ) : (
                    <XCircle className="text-danger" size={20} />
                  )}
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span>Assessment</span>
                  {course.assessment ? (
                    <CheckCircle className="text-success" size={20} />
                  ) : (
                    <XCircle className="text-danger" size={20} />
                  )}
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span>Project</span>
                  {course.project ? (
                    <CheckCircle className="text-success" size={20} />
                  ) : (
                    <XCircle className="text-danger" size={20} />
                  )}
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span>Feedback</span>
                  {course.feedback ? (
                    <CheckCircle className="text-success" size={20} />
                  ) : (
                    <XCircle className="text-danger" size={20} />
                  )}
                </div>
                {course.digitalLearning &&
                course.assessment &&
                course.project &&
                course.feedback ? (
                  <div className="d-flex justify-content-center mt-4">
                    <Button variant="primary">Generate Certificate</Button>
                  </div>
                ) : null}
              </Card.Body>   
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default CourseCard;
